
export class UserFeedback {
    //this is NOT the same as user sub, it is identity sub for IAM
    private UserSub: string = null;
    public Date:string;// = new Date().toISOString();
    public Type:string = "Feedback";
    public Message:string = "";
    public UserName:string;
    constructor()
    {
    }
  }


// WEBPACK FOOTER //
// ./src/providers/user-feedback.ts